
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const MeasurementsPage = () => {
  return (
    <div className="min-h-screen bg-primary">
      <Navbar />
      <main className="pt-24 pb-20">
        <div className="container mx-auto px-6 max-w-5xl">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-accent mb-4">دليل المقاسات</h1>
            <p className="text-lg text-gray-600">
              تعلم كيفية أخذ المقاسات بدقة للحصول على أفضل نتيجة
            </p>
          </div>

          {/* Video Section */}
          <div className="bg-white rounded-3xl p-8 shadow-sm mb-12">
            <h2 className="text-2xl font-bold text-accent mb-6 flex items-center gap-2">
              <i className="ri-video-line text-secondary"></i>
              فيديو توضيحي لطريقة أخذ المقاسات
            </h2>
            <div className="aspect-video bg-gray-100 rounded-2xl overflow-hidden">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                title="دليل المقاسات"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
            <p className="text-gray-600 mt-4">
              شاهد الفيديو التوضيحي لتتعلم الطريقة الصحيحة لأخذ المقاسات بدقة
            </p>
          </div>

          {/* Measurements Guide */}
          <div className="bg-white rounded-3xl p-8 shadow-sm mb-12">
            <h2 className="text-2xl font-bold text-accent mb-6 flex items-center gap-2">
              <i className="ri-ruler-line text-secondary"></i>
              دليل القياسات المطلوبة
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Image */}
              <div className="bg-gray-50 rounded-2xl p-6 flex items-center justify-center">
                <img
                  src="https://public.readdy.ai/ai/img_res/166a0f298e515497cb019205c72ab712.jpg"
                  alt="دليل المقاسات"
                  className="w-full h-auto object-contain"
                />
              </div>

              {/* Measurements List */}
              <div className="space-y-4">
                <div className="border-r-4 border-secondary pr-4">
                  <h3 className="text-lg font-bold text-accent mb-2">1. طول الثوب</h3>
                  <p className="text-gray-600">
                    قس من أعلى الكتف إلى الطول المطلوب (عادة حتى الكاحل)
                  </p>
                </div>

                <div className="border-r-4 border-secondary pr-4">
                  <h3 className="text-lg font-bold text-accent mb-2">2. قياس الرقبة</h3>
                  <p className="text-gray-600">
                    قس محيط الرقبة بشريط القياس بشكل مريح
                  </p>
                </div>

                <div className="border-r-4 border-secondary pr-4">
                  <h3 className="text-lg font-bold text-accent mb-2">3. عرض الكتف</h3>
                  <p className="text-gray-600">
                    قس المسافة بين نهاية الكتف الأيمن والأيسر
                  </p>
                </div>

                <div className="border-r-4 border-secondary pr-4">
                  <h3 className="text-lg font-bold text-accent mb-2">4. طول الكم</h3>
                  <p className="text-gray-600">
                    قس من نهاية الكتف إلى المعصم
                  </p>
                </div>

                <div className="border-r-4 border-secondary pr-4">
                  <h3 className="text-lg font-bold text-accent mb-2">5. عرض الصدر</h3>
                  <p className="text-gray-600">
                    قس محيط الصدر عند أوسع نقطة
                  </p>
                </div>

                <div className="border-r-4 border-secondary pr-4">
                  <h3 className="text-lg font-bold text-accent mb-2">6. عرض البطن</h3>
                  <p className="text-gray-600">
                    قس محيط البطن عند منطقة السرة
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Standard Sizes Table */}
          <div className="bg-white rounded-3xl p-8 shadow-sm mb-12">
            <h2 className="text-2xl font-bold text-accent mb-6 flex items-center gap-2">
              <i className="ri-table-line text-secondary"></i>
              جدول المقاسات القياسية
            </h2>

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="px-6 py-4 text-right text-accent font-bold">المقاس</th>
                    <th className="px-6 py-4 text-center text-accent font-bold">صغير (S)</th>
                    <th className="px-6 py-4 text-center text-accent font-bold">وسط (M)</th>
                    <th className="px-6 py-4 text-center text-accent font-bold">كبير (L)</th>
                    <th className="px-6 py-4 text-center text-accent font-bold">كبير جداً (XL)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t">
                    <td className="px-6 py-4 text-gray-700">طول الثوب</td>
                    <td className="px-6 py-4 text-center text-gray-600">150 سم</td>
                    <td className="px-6 py-4 text-center text-gray-600">155 سم</td>
                    <td className="px-6 py-4 text-center text-gray-600">160 سم</td>
                    <td className="px-6 py-4 text-center text-gray-600">165 سم</td>
                  </tr>
                  <tr className="border-t bg-gray-50">
                    <td className="px-6 py-4 text-gray-700">محيط الصدر</td>
                    <td className="px-6 py-4 text-center text-gray-600">100 سم</td>
                    <td className="px-6 py-4 text-center text-gray-600">110 سم</td>
                    <td className="px-6 py-4 text-center text-gray-600">120 سم</td>
                    <td className="px-6 py-4 text-center text-gray-600">130 سم</td>
                  </tr>
                  <tr className="border-t">
                    <td className="px-6 py-4 text-gray-700">طول الكم</td>
                    <td className="px-6 py-4 text-center text-gray-600">58 سم</td>
                    <td className="px-6 py-4 text-center text-gray-600">60 سم</td>
                    <td className="px-6 py-4 text-center text-gray-600">62 سم</td>
                    <td className="px-6 py-4 text-center text-gray-600">64 سم</td>
                  </tr>
                  <tr className="border-t bg-gray-50">
                    <td className="px-6 py-4 text-gray-700">عرض الكتف</td>
                    <td className="px-6 py-4 text-center text-gray-600">44 سم</td>
                    <td className="px-6 py-4 text-center text-gray-600">46 سم</td>
                    <td className="px-6 py-4 text-center text-gray-600">48 سم</td>
                    <td className="px-6 py-4 text-center text-gray-600">50 سم</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Tips */}
          <div className="bg-white rounded-3xl p-8 shadow-sm mb-12">
            <h2 className="text-2xl font-bold text-accent mb-6 flex items-center gap-2">
              <i className="ri-lightbulb-line text-secondary"></i>
              نصائح مهمة
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex gap-4">
                <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-secondary text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-accent mb-2">استخدم شريط قياس مرن</h3>
                  <p className="text-gray-600">
                    للحصول على قياسات دقيقة، استخدم شريط قياس مرن وليس مسطرة
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-secondary text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-accent mb-2">قس وأنت واقف</h3>
                  <p className="text-gray-600">
                    تأكد من الوقوف بشكل مستقيم عند أخذ المقاسات
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-secondary text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-accent mb-2">لا تشد الشريط</h3>
                  <p className="text-gray-600">
                    اجعل شريط القياس مريحاً وليس مشدوداً أو فضفاضاً
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-secondary text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-accent mb-2">استعن بشخص آخر</h3>
                  <p className="text-gray-600">
                    من الأفضل أن يساعدك شخص آخر في أخذ المقاسات
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div className="bg-secondary text-white rounded-3xl p-8 text-center">
            <i className="ri-customer-service-2-line text-5xl mb-4"></i>
            <h2 className="text-2xl font-bold mb-4">هل تحتاج مساعدة؟</h2>
            <p className="text-lg mb-6">
              فريقنا جاهز لمساعدتك في أخذ المقاسات الصحيحة
            </p>
            <a
              href="https://wa.me/96512345678"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-white text-secondary px-8 py-4 rounded-full text-lg font-medium hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap"
            >
              تواصل معنا عبر واتساب
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MeasurementsPage;
